import { storeRef } from "@/components/providers/StoreProvider"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { thunks } from "@/lib/redux/thunks"
import { controllers } from "@/lib/services"
import { track } from "@/lib/tracking"

// DOP-925: dedupe hotel_search — 1 lượt search của user có thể gọi hàm này 2 lần
// (submit form + HotelsResultContainer mount, cách nhau vài giây tùy navigation)
let lastTrackedSearch = { key: '', at: 0 }
const TRACK_SEARCH_DEDUPE_MS = 15 * 60 * 1000

export const getHotels = async ({
  pageSize = 20,
  page = 0,
  sort,
  lat,
  lng,
  radius,
  locale
}: {
  page: number,
  lat?: number,
  lng?: number,
  radius?: number,
  pageSize: number,
  sort?: number,
  locale?: string,
}) => {
  const hotelState = storeRef.current?.getState().hotel
  const formSearch = hotelState?.formSearch
  const mode = hotelState?.mode
  if (page === 0) {
    storeRef.current?.dispatch(hotelActions.setFirstLoading(true))
    storeRef.current?.dispatch(hotelActions.resetHotelsSearch())

    // DOP-925: tracking hotel_search — page 0 = search mới; dedupe theo bộ tham số
    // (đổi địa điểm/ngày/khách → key đổi → track bình thường)
    const searchTrackProperties = {
      city_id: parseInt(`${formSearch?.currentLocation?.id || '0'}`),
      search_type: formSearch?.currentLocation?.searchType || 'CITY',
      checkin: formSearch?.checkInDate,
      checkout: formSearch?.checkOutDate,
      room: formSearch?.roomsNum,
      guest: (formSearch?.adults || 0) + (formSearch?.children || 0),
    }
    const searchTrackKey = JSON.stringify(searchTrackProperties)
    if (searchTrackKey !== lastTrackedSearch.key || Date.now() - lastTrackedSearch.at > TRACK_SEARCH_DEDUPE_MS) {
      lastTrackedSearch = { key: searchTrackKey, at: Date.now() }
      track('hotel_search', searchTrackProperties)
    }
  }

  if (controllers.hotels_search) {
    controllers.hotels_search.abort("New request")
    controllers.hotels_search = new AbortController()
  }

  // Lỗi (kể cả request bị abort khi search lại) đã được reducer rejected xử lý;
  // các nơi gọi không catch nên nuốt ở đây để không thành unhandledRejection.
  let failed = false
  const res = await storeRef.current?.dispatch(thunks.hotels_search({
    body: {
      ...formSearch,
      TYPE: 'JSON',
      lat: undefined,
      lng: undefined,
      radius: undefined,
      filter: Object.values(formSearch?.filter || {}),
      location: undefined,
      init: undefined,
      hotel: undefined,
      currentLocation: undefined,
      voucherCode: undefined,
      order: undefined,
      locationId: parseInt(`${formSearch?.currentLocation?.id || '0'}`),
      searchType: formSearch?.currentLocation?.searchType || 'CITY',
      page,
      pageSize,
      locale: locale === 'en' ? 'en' : 'vn',
      searchMode: 'OTA',
      ...(lat && lng && radius ? {
        searchOption: {
          lat, long: lng, radius
        }
      } : {}),
      ...(sort ? {
        sort: {
          selectOption: sort
        }
      } : {})
    },
    params: {
      locale: locale === 'en' ? 'en' : 'vn',
    },
  })).unwrap().catch(() => {
    failed = true
  })

  if (failed) return []

  if (page === 0) {
    storeRef.current?.dispatch(hotelActions.setFirstLoading(false))
  }

  return res?.records || []
}